function linkWorkOrderMentions(text) {
  return String(text ?? '').replace(/work order #(\d+)/gi, (phrase, id) =>
    phrase.replace(`#${id}`, `[#${id}](/mworkorders?search=:${id})`),
  );
}

function workOrderIdFromChatHref(href) {
  const match = String(href || '').match(/\/mworkorders\?search=:(\d+)\b/);
  if (!match) return null;
  const id = Number(match[1]);
  return id > 0 ? id : null;
}

module.exports = {
  linkWorkOrderMentions,
  workOrderIdFromChatHref,
};
